export default "__VITE_ASSET__CJqvJd41__"